import { useEffect, useState } from "react";
import api from "@/lib/api";
import DashboardShell from "@/components/nav/DashboardShell";
import { toast } from "sonner";

const CATEGORIES = ["All","Email","Calendar","CRM","Documents","Communication","Industry Software","Automation","Other"];

export default function Integrations() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("All");

  const load = () => api.get("/integrations").then(({data}) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (slug, connect) => {
    try {
      await api.post("/integrations/toggle", { integration_slug: slug, connect });
      toast.success(connect ? "Connected" : "Disconnected");
      load();
    } catch { toast.error("Failed"); }
  };

  const filtered = cat === "All" ? items : items.filter(i => i.category === cat);

  return (
    <DashboardShell>
      <div className="brand-eyebrow mb-4">TOOLS</div>
      <h1 className="brand-headline text-4xl md:text-6xl mb-8">Integrations.</h1>

      <div className="flex gap-2 flex-wrap mb-8">
        {CATEGORIES.map(c => (
          <button key={c} data-testid={`int-cat-${c.replace(/\s+/g,'-').toLowerCase()}`} onClick={() => setCat(c)}
            className={`text-[10px] tracking-widest font-bold px-3 py-1.5 border ${cat===c ? "bg-gold text-ink border-gold" : "text-smoke border-line hover:border-gold"}`}>{c.toUpperCase()}</button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filtered.map(i => (
          <div key={i.slug} className="border border-line p-6">
            <div className="text-xs tracking-widest text-smoke">{i.category}</div>
            <div className="text-white text-xl font-semibold mt-1">{i.name}</div>
            <div className="text-smoke text-sm mt-2">{i.description}</div>
            <div className="flex items-center justify-between mt-6">
              <StatusPill status={i.status} />
              {i.status === "CONNECTED" ? (
                <button data-testid={`int-disconnect-${i.slug}`} onClick={() => toggle(i.slug, false)} className="text-xs text-smoke hover:text-white border border-line px-3 py-1.5">Disconnect</button>
              ) : (
                <button data-testid={`int-connect-${i.slug}`} onClick={() => toggle(i.slug, true)} className="text-xs bg-gold text-ink px-3 py-1.5 font-bold">Connect</button>
              )}
            </div>
            {i.last_sync && <div className="text-[10px] text-smoke mt-3">Last sync: {new Date(i.last_sync).toLocaleString()}</div>}
          </div>
        ))}
      </div>
    </DashboardShell>
  );
}

function StatusPill({ status }) {
  const map = { "CONNECTED": ["dot-green", "text-emerald-400"], "ERROR": ["dot-red","text-red-400"], "NOT CONNECTED": ["dot-gray","text-smoke"] };
  const [d, c] = map[status] || map["NOT CONNECTED"];
  return <span className={`text-[10px] tracking-widest font-bold flex items-center gap-2 ${c}`}><span className={`dot ${d}`} />{status}</span>;
}
